module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$store.state.alert_success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v("\n\t\t\t" + _vm._s(_vm.$store.state.alert_message != '' ? _vm.$store.state.alert_message : 'Operação realizada com sucesso!') + "\n\t")]) : _vm._e(), _vm._v(" "), (this.$store.state.alert_error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v("\n\t\t\t" + _vm._s(_vm.$store.state.alert_message != '' ? _vm.$store.state.alert_message : 'Ocorreu um erro ao realizar a operação!') + "\n\t")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" Sucesso! ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" Erro! ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-507cec02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 846
// module chunks = 0